import classnames from "classnames";
import React, { useState } from "react";
import "./Accordion.scss";
import * as Commons from "oc-commons/Commons";

export function Accordion({ groups, openSingleGroup = false }) {
  const [open, setOpenIntern] = useState(
    () => new Set(groups.filter((group) => group.open).map((group) => group.key))
  );
  const toggleOpen = (group) => {
    const key = group.key;
    setOpenIntern(new Set(open.has(key) ? [...open].filter((x) => x != key) : [...open, key]));
  };
  const isOpen = (group) => (openSingleGroup && groups.length == 1) || open.has(group?.key);

  return (
    <div className="accordion">
      {groups.map((group) => (
        <div key={group.key} data-key={group.key} className="accordion-entry">
          {!(Commons.isEmpty(group.title) && groups.length == 1) && (
            <div
              key="head"
              className={classnames("accordion-header", isOpen(group) ? "open" : "closed")}
              onClick={() => toggleOpen(group)}
            >
              {group.title}
            </div>
          )}
          {isOpen(group) && (
            <div key="body" className="accordion-body">
              {group.body()}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
